/**
 * Shared labels and chip styling for hosting providers (asset discovery).
 * Used by Assets, Runbooks, and Operations for consistent chip display.
 */

export const PROVIDER_LABELS: Record<string, string> = {
  aws: 'AWS',
  aws_cloudfront: 'AWS CloudFront',
  aws_alb: 'AWS ALB/NLB',
  gcp: 'GCP',
  azure: 'Azure',
  azure_cdn: 'Azure CDN/FD',
  cloudflare: 'Cloudflare',
  fastly: 'Fastly',
  akamai: 'Akamai',
  akamai_cloud: 'Akamai Cloud',
  imperva: 'Imperva/Incapsula',
  digitalocean: 'DigitalOcean',
  hetzner: 'Hetzner',
  ovh: 'OVH',
  vultr: 'Vultr',
  oracle_cloud: 'Oracle Cloud',
  ibm_cloud: 'IBM Cloud',
  alibaba_cloud: 'Alibaba Cloud',
  tencent_cloud: 'Tencent Cloud',
  leaseweb: 'LeaseWeb',
  webflow: 'Webflow',
  squarespace: 'Squarespace',
  shopify: 'Shopify',
  wix: 'Wix',
  netlify: 'Netlify',
  vercel: 'Vercel',
  github: 'GitHub',
  wordpress: 'WordPress.com',
  wpengine: 'WP Engine',
  kinsta: 'Kinsta',
  pantheon: 'Pantheon',
  flywheel: 'Flywheel',
  on_prem: 'On-Prem',
  unknown: 'Unknown',
  unknown_or_on_prem: 'On-Prem',
};

export function providerLabel(provider?: string | null): string {
  if (!provider) return 'Unknown';
  return PROVIDER_LABELS[provider] ?? provider;
}

export type ProviderChipColor = 'success' | 'info' | 'secondary' | 'warning' | 'default' | 'error';

export function providerChipColor(provider?: string | null): ProviderChipColor {
  const p = (provider || '').toLowerCase();
  if (p.startsWith('aws')) return 'warning';
  if (p === 'gcp') return 'info';
  if (p.startsWith('azure')) return 'secondary';
  if (p === 'cloudflare' || p === 'fastly' || p === 'akamai' || p === 'akamai_cloud') return 'success';
  if (p === 'on_prem' || p === 'unknown_or_on_prem') return 'default';
  if (p === 'unknown') return 'error';
  if (['digitalocean', 'hetzner', 'ovh', 'vultr', 'oracle_cloud', 'ibm_cloud',
       'alibaba_cloud', 'tencent_cloud', 'imperva', 'leaseweb'].includes(p)) return 'info';
  if (['webflow', 'squarespace', 'shopify', 'wix', 'netlify', 'vercel',
       'github', 'wordpress', 'wpengine', 'kinsta', 'pantheon', 'flywheel'].includes(p)) return 'secondary';
  return 'default';
}
